import { render, staticRenderFns } from "./localgoods.vue?vue&type=template&id=04ebad82&scoped=true&"
import script from "./localgoods.vue?vue&type=script&lang=js&"
export * from "./localgoods.vue?vue&type=script&lang=js&"
import style0 from "./localgoods.vue?vue&type=style&index=0&id=04ebad82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebad82",
  null
  
)

export default component.exports